<template>
    <div class="wrapper">
      <div class="text-center mb-24 main-two-step-auth-logo">
        <img class="two-step-auth-logo" src="@/assets/images/logo3.svg">
        <img v-if="this.showCloseIcon" @click="closeConfirmationTwoStepAuthModal()" class="close-two-step-auth-icon" src="@/assets/images/close-icon.svg">
      </div>

      <div class="content text-center mb-40">
        <p v-if="action == 'enable_otp'" class="main-title mb-40">{{ $t('form.twoStepAuthentication')}}</p>
        <p v-if="action == 'login'" class="main-title mb-16">{{ $t('common.passportAcc').toUpperCase()}}</p>
        <p v-if="action == 'login'" class="main-sub-title mb-40">{{ $t('common.login')}}</p>

        <div v-if="registerWithEmail">
          <p class="second-title mb-24">{{ $t('validation.checkEmail')}}</p>
          <p class="third-title " :class="{'mb-40' : !errorCode}">{{ $t('confirmation.twoStepAuth') }}</p>
        </div>

        <div v-if="registerWithPhone">
          <p class="second-title mb-24">{{ $t('common.checkPhone')}}</p>
          <p class="third-title " :class="{'mb-40' : !errorCode}">{{ $t('confirmation.twoStepSMS') }}</p>
        </div>

        <p v-if="errorCode" class="invalid-code-text">{{ $t('common.invalidCode')}}</p>

        <div class="confirmation-code-section">
          <div class="code-sent-text mb-24">{{ $t('common.sentTo')}}</div>
          <div v-if="email" class="registration-account"> {{email}} </div>
          <div v-else class="registration-account"> {{phone}} </div>
          <div class="d-flex code-section mb-32">
            <input v-for="(input,index) in inputsLength" :key="index" @paste="onPasteCode($event)" @keyup="moveToNext($event, index)" type="text" maxlength="1"
            class="otp-code-input" :class="{'error-code' : errorCode, 'ml-16' : index > 0 }" v-model="otp_numbers[index]"/>
          </div>

          <div id="timer" class="timer-text mb-24">00:59</div>  
          <button @click="onResendCode()" class="btn" :disabled="!enableResendCode" :class="enableResendCode ? 'resend-text' : 'resend-text-disabled'">{{ $t('common.resend')}}</button>
        </div>

      </div>

      <button class="verify-btn btn btn-primary" size="md" @click="onSubmit" :disabled="isSubmitted || otp.length != 6 || errorCode" >
        <i v-if="isSubmitted" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded" ></i> 
        <span v-else >{{ $t('common.verify').toUpperCase() }}</span>
      </button>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import router from "../../router/index";
  export default {
    props: ["showCloseIcon", "action"],
    data() {
      return {
        isSubmitted: false,
        errorCode : false,
        maxLength : 1,
        registerWithEmail : false,
        registerWithPhone : false,
        count : 60,
        counter : null,
        enableResendCode : false,
        email : null,
        phone : null,
        inputsLength: 6,
        otp_numbers: [],
        regexNumberPattern : /^\d*$/
      };
    },
    computed: {
      ...mapGetters("user", [ "getUserData", 'getUserEmail', 'getUserPhone']),
      otp() {
        let code = this.otp_numbers.join('');
        return code.replace(/\D/g,'');
        // return code;
      }
    },
    watch: {
      otp_numbers : function (value) {
        console.log('value', value);
      },
    },
    methods: {
      ...mapActions("user", ["resetState"]),
      ...mapActions("authfack", [ "sendOtpAuthCode" , "verifyOtpAuthCode", "updateUserOtpAuthStatus", "logout" ]),
      timer () {
        this.count -= 1;
        // console.log('count', this.count);
        if (this.count == 0 ) {
          this.count = 60;
          this.enableResendCode = true;
          clearInterval(this.counter);
          document.getElementById("timer").innerHTML = "00:00";
        }else{
          if(this.count > 9){
            document.getElementById("timer").innerHTML = "00:" + this.count;
          }else {
            document.getElementById("timer").innerHTML = "00:0" + this.count;
          }
        } 
      },
      startTimer() {
        this.counter = setInterval(() => { this.timer() }, 1000);
      },
      onResendCode(){
        this.count = 60;
        this.enableResendCode = false;
        this.errorCode = false;
        this.otp_numbers=[];
        this.onFoucsFirstInput();
        this.startTimer();
        this.sendOtpAuthCode({
          action : this.$route.name == 'confirmVericationCode' ? 'login' : 'enable_otp'
        });
      },
      closeConfirmationTwoStepAuthModal(){
        clearInterval(this.counter);
        this.$bvModal.hide('verifyOtpCodeModal')
      },
      async moveToNext(e, index) {
        console.log('e moveToNext', e);
        console.log('index', index);
        this.errorCode = false;
        if(e.which == 13 && e.key == 'Enter' && this.otp && this.otp.length == 6) {
         this.onSubmit();
        } else if(e.which == 8 && e.key == 'Backspace') {
          if(index > 0 ) document.getElementsByClassName('otp-code-input')[index - 1].focus()
        } else if(!isNaN(Number(e.key))){
          if(e.target.value.length > 0) e.target.value = e.target.value.charAt(0);
          e.target?.nextSibling?.focus(); 
        }else if (( (e.key.length === 1 && isNaN(Number(e.key))) || (e.key == "Meta" && e.keyCode == 91)) && !this.regexNumberPattern.test(e.target.value)) {
          e.target.value = null;
          e.returnValue = false;
          this.otp_numbers = [];
          this.getOtpInputs([]);
          await e.preventDefault();
          await e.stopImmediatePropagation();
          return false;
        }
      },
      async onPasteCode(e){
        console.log('e paste', e);
        console.log('e paste text',  e.clipboardData.getData('text'));
        let code = e.clipboardData.getData('text');
        code = code.split('');
        console.log('code', code);
        if(code && code.length == 6){
          this.getOtpInputs(code);
          this.otp_numbers = code;
          console.log('this.otp_numbers', this.otp_numbers.length);
          console.log('this.otp', this.otp);
        }
      },
      getOtpInputs(code){
        let elements = document.getElementsByClassName('otp-code-input');
        // console.log('elements', elements);
        for(let i= 0; i < elements.length; i++){
          elements[i].value = parseInt(code[i]);
        }
      },
      onSubmit() {
        this.isSubmitted = true;
        if(this.$route.name == 'confirmVericationCode'){
            this.verifyOtpAuthCode({
            'otp' : this.otp
          }).then(async (res) => {
            console.log('res', res);
            await clearInterval(this.counter);
            await localStorage.setItem("userIsVerified", 1);
            router.push("/dashboard");
          }).catch((e) => {
            console.log('e', e);
            this.isSubmitted = false;
            if(!e.data?.data) {
              this.errorCode = true;
            }
          });
        }else{
          this.updateUserOtpAuthStatus({
            'otp_enabled' : true,
            'otp' : this.otp
          }).then(async (res) => {
            console.log('res', res);
            clearInterval(this.counter);
            await localStorage.setItem("userOtpRequired", 0);
            await localStorage.setItem("userIsVerified", 0);
            this.logout();
          }).catch((e) => {
            console.log('e', e);
            this.isSubmitted = false;
            if(!e.data?.data) {
              this.errorCode = true;
            }
          });
        }
      },
      onFoucsFirstInput(){
        let element = document.getElementsByClassName('otp-code-input')[0];
        // console.log('elements', element);
        if(element) element.focus();
      }
    },
    mounted() {
      this.startTimer();
      setTimeout(()=>{
        this.onFoucsFirstInput();
      },200)
      // console.log('getUserData', this.getUserData);
      if(this.getUserEmail) {
        this.registerWithEmail = true;
        this.email = this.getUserEmail;
      }else if(this.getUserPhone){
        this.registerWithPhone = true;
        this.phone = this.getUserPhone;
      }
    },
    destroyed() {
      this.closeConfirmationTwoStepAuthModal();
    },
    beforeMount() {
      this.resetState();
    },
  };
  </script>
  <style>
    div#verifyOtpCodeModal___BV_modal_body_{
      padding: 40px 42px !important;
    }
  </style>
  <style lang="scss" scoped>

  .wrapper {
      .text-title {
      font-size: 16px;
      margin-bottom: 24px;
      text-align: center;
      color: #4A4A4A;
      font-weight: 400;
      }
      .err-wrapper {
      padding-left: 53px;
      margin-top: 2px;
      }
      .h-line{
          margin-top: 40px !important;
          margin-bottom: 24px !important;
      }

      .action-btns {
          .submit-btn {
              margin-inline-end: 32px;
          }
      }
  }

  .close-two-step-auth-icon {
    cursor: pointer;
  }

  .main-title {
    font-size: 16px;
    font-family: 'Lato';
    font-weight: 700;
    line-height: 19.2px;
    color: #000000;
  }

  .main-sub-title{
    color: #787878;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    text-align: center;
  }

  .second-title {
    font-size: 16px;
    font-family: 'Lato';
    font-weight: 500;
    line-height: 19.2px;
    color: #000000;
  }

  .third-title {
    font-size: 16px;
    font-family: 'Lato';
    font-weight: 400;
    line-height: 19.2px;
    color: #787878;
  }

  .confirmation-code-section {
    width: 416px;
    height: auto;
    border-radius: 17px;
    background: #F2F2F2;
    padding: 24px;
  }

  .code-sent-text{
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    text-align: center;
  }

  .registration-account {
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px; 
    text-align: center;
    color: #103F5E;
    margin-bottom: 32px;

  }

  .otp-code-input-disabled{
    width: 44px;
    height: 49px;
    border-radius: 4px;
    opacity: 0px;
    border: 2px solid #9FB2BF

  }

  .otp-code-input{
    width: 44px;
    height: 49px;
    border-radius: 4px;
    border: none;
    font-family: Lato;
    font-size: 45px;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #103F5E;
    background-color: #FFFFFF !important;
  }
  
  .code-section {
    margin-left: 12px;
  }

  .verify-btn{
    width: 416px;
    border-radius: 22px;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    text-align: center;

  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .error-code {
    color: #F46A6A;
  }

  .invalid-code-text {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 16.8px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #F46A6A;
    margin-top: 32px;
    margin-bottom: 32px;
  }

  .timer-text {
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    color: #4A4A4A;
  } 

  .resend-text {
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    color: #103F5E !important;
    cursor: pointer !important;
  }

  .resend-text-disabled { 
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    cursor: not-allowed !important;
    color: #9FB2BF !important;
  }


  .modal-content .modal-body.modal-form {
    padding: 40px 42px !important;
  }

  .text-center.mb-24.main-two-step-auth-logo {
    height: 16px;
    line-height: 13px;
  }

  p.main-title.mb-40 {
    height: 12px;
    line-height: 12px;
  }

  p.second-title.mb-24 {
    height: 12px;
    line-height: 12px;
  }

  p.third-title {
    line-height: 24px !important;
  }

  .confirmation-code-section {
    padding: 24px 36px !important;
  }

  .code-sent-text.mb-24 {
    color: #4A4A4A;
    height: 11px;
    line-height: 10px;
  }

  .registration-account {
    height: 12px;
    line-height: 11px !important;
  }

  .d-flex.code-section.mb-32 {margin-left: 0;}

  input.otp-code-input:focus-visible {
      outline-color: #9FB2BF;
  }

  div#timer {
    height: 11px;
    line-height: 10px;
  }

  button.btn.resend-text {
    padding: 0;
    height: 12px;
    line-height: 10px;
  }

  button.verify-btn.btn.btn-primary {
    height: 44px;
    line-height: 19px;
  }


  p.invalid-code-text {
    height: 10px;
    line-height: 10px !important;
  }

  button.btn.resend-text-disabled {
    opacity: 1;
    padding: 0;
    height: 12px;
    line-height: 10px;
  }
  

  .forget-password-wrapper .content {
    padding: 40px 42px !important;
  }

  .text-center.mb-24.main-two-step-auth-logo {
    line-height: 16px !important;
  }

  .content.text-center.mb-40 {
    padding: 0 !important;
  }

  p.main-title.mb-16 {
    height: 12px;
    line-height: 12px;
  }

  p.main-sub-title.mb-40 {
    height: 12px;
    line-height: 12px;
  }

  p.second-title.mb-24 {
    height: 11px !important;
    line-height: 11px !important;
  }

  p.third-title.mb-40 {
    height: 35px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
  }
</style>
  